/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_ClaimInputs */

const en_scene_outside_claim = /** @type {(inputs: Scene_Outside_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim`)
};

/**
* | output |
* | --- |
* | "Claim" |
*
* @param {Scene_Outside_ClaimInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_claim = /** @type {((inputs?: Scene_Outside_ClaimInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_ClaimInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_claim(inputs)
});